export default {
	huanyinghuilai: 'Selamat datang kembali',
	wodezhanghu: 'Akun saya',
	gerenxinxi: 'Informasi pribadi',
	jiatingyupengyou: 'Keluarga & teman',
	fukuanshijian: 'Waktu Pembayaran',
	fukuanfangshi: 'Metode Pembayaran',
	fukuanjine: 'Jumlah Pembayaran',
	genggaimima: 'Ganti Kata Sandi',
	quebaoxinxizhengque:
		'Harap pastikan bahwa semua informasi sudah benar. Semua Gelar dan nama Penumpang harus dimasukkan sesuai dengan paspor atau dokumen perjalanan lain yang sah.',
	zhuxiao: 'Keluar',
	quedingyaodengchuma: 'apakah anda yakin ingin keluar?',
	tuichuchenggong: 'Berhasil keluar',
	nishifeixingchangkema: 'Apakah anda bagian dari program frequent flyer?',
	lijitianjianindejiarenhepengyou: 'Tambahkan keluarga dan teman anda sekarang',
	tianjianindepengyou: 'Tambahkan detail keluarga dan teman anda untuk proses pemesanan yang lebih cepat.',
	xinzeng: 'Tambah baru',
	lijitianjiaka: 'Tambahkan kartu sekarang',
	tianjiaka: 'Tambahkan kartu untuk proses pemesanan lebih cepat.',
	bianji: 'Ganti',
	shanchu: 'Hapus',
	querenshanchuchengkexinxime: 'Apakah Anda yakin akan menghapus informasi penumpang?'
};
